import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Bell, Trash } from 'react-bootstrap-icons';
import './Node.css';

const WaitForEventNode = ({ data, id, outputEdges, onEdgeCountChange }) => {
  // Define color scheme
  const colors = {
    container: 'custom-node node-rounded-lg node-border-red',
    header: 'node-header node-bg-red-gradient node-border-red-bottom',
    text: 'node-text-red',
    handle: 'node-handle-small node-handle-red'
  };

  const edgeLabels = [];
  
  // Add hover state
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div 
      className={`${colors.container} node-hover-lift`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Delete button - Added opacity and transition */}
      <div 
        className={`delete-btn delete-btn.top-center ${isHovered ? 'show' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          if (data.onDelete) {
            data.onDelete(id);
          }
        }}
      >
        <Trash className='icon-trash'/>
      </div>

      {/* Header section */}
      <div className={colors.header}>
        <div className="node-header-content">
          <Bell className='node-icon' style={{ color: '#d6201c' }}/>
          <span className={`node-title ${colors.text}`}>Wait for Event</span>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Left}
        className={colors.handle}
      />
      
      {/* Output handles */}
      <div className="node-output-handles">
        {Array.from({ length: outputEdges }).map((_, index) => (
          <Handle
            key={`output-${index}`}        
            type="source"
            position={Position.Right}
            id={`output-${index}`}
            className={colors.handle}
            style={{ 
              top: `${((index + 1) * 100) / (outputEdges + 1)}%`
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default WaitForEventNode; 
